"use client"

import { Copy } from "lucide-react"
import { toast } from "sonner"

export default function CopyRewardsURL({ url }: { url: string }) {
  return (
    <div className="block font-mono text-muted-foreground bg-wood-50 dark:bg-wood-900  rounded-md p-4 text-xs sm:text-sm break-all ">
      <div className="flex items-center gap-2 justify-between">
        <div className="truncate">{url}</div>
        <Copy
          className="h-5 w-5 text-muted-foreground cursor-pointer flex-shrink-0 ml-1"
          onClick={() => {
            navigator.clipboard.writeText(url)
            toast.success("Copied to clipboard")
          }}
        />
      </div>
    </div>
  )
}
